module.exports = __webpack_public_path__ + "img/album08_09.2261f8a8.jpg";